export default {
  Authenticating: "I agree",
  InvalidUsername: ""
};
